import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-graph-up",
  "use": "icon-graph-up-usage",
  "viewBox": "0 0 24.000000 24.000000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24.000000 24.000000\" preserveAspectRatio=\"xMidYMid meet\" id=\"icon-graph-up\">\n\n<g transform=\"translate(0.000000,24.000000) scale(0.100000,-0.100000)\" stroke=\"none\">\n<path d=\"M188 178 c9 -9 5 -19 -20 -45 l-32 -33 -23 22 -23 22 -40 -39 c-22\n-22 -40 -44 -40 -49 0 -6 18 7 40 29 l40 39 25 -24 25 -24 38 37 c30 29 41 34\n50 25 9 -9 12 -5 12 20 0 29 -3 32 -32 32 -25 0 -29 -3 -20 -12z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol